module.exports = __webpack_public_path__ + "img/BAN_LE.e5c16d6c.svg";